"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.ExpandoHelpComponent = void 0;
var widgets_1 = require("@tableau/widgets");
var React = require("react");
var Localize_1 = require("../gen-src/Localize");
var DialogStyles_1 = require("./styles/DialogStyles");
var TelemetryConstants = require("./telemetry/TelemetryConstants");
var TelemetryHelper_1 = require("./telemetry/TelemetryHelper");
var ExpandoHelpComponent = /** @class */ (function (_super) {
    __extends(ExpandoHelpComponent, _super);
    function ExpandoHelpComponent(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { isExpanded: false };
        TelemetryHelper_1.TelemetryHelper.addOrUpdateTelemetry(TelemetryConstants.ExpandHelpCount, 0);
        return _this;
    }
    ExpandoHelpComponent.prototype.render = function () {
        var _this = this;
        return (React.createElement(widgets_1.ExpandoWidget, { className: DialogStyles_1.DialogStyles.HelpExpando, label: Localize_1.Messages.ExpandLabel(), direction: widgets_1.ExpandoDirection.Down, isExpanded: this.state.isExpanded, onCollapse: function () {
                _this.setState({ isExpanded: false });
                ExpandoHelpComponent.IncrementExpandedCount();
            }, onExpand: function () {
                _this.setState({ isExpanded: true });
                ExpandoHelpComponent.IncrementExpandedCount();
            }, testId: "open-workbook-dialog-expando" },
            React.createElement("p", { className: DialogStyles_1.DialogStyles.ExpandMessage }, this.props.isTableauOnline ? Localize_1.Messages.ExpandOnlineMessage() : Localize_1.Messages.ExpandServerMessage())));
    };
    ExpandoHelpComponent.IncrementExpandedCount = function () {
        TelemetryHelper_1.TelemetryHelper.addOrIncrementTelemetryCounter(TelemetryConstants.ExpandHelpCount);
    };
    return ExpandoHelpComponent;
}(React.PureComponent));
exports.ExpandoHelpComponent = ExpandoHelpComponent;
//# sourceMappingURL=ExpandoHelpComponent.js.map